import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

export default class ColoredScrollbars extends Component {

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = { left: 0 };
        this.handleUpdate = this.handleUpdate.bind(this);
        this.renderView = this.renderView.bind(this);
        this.renderThumb = this.renderThumb.bind(this);
    }

    handleUpdate(values) {
        const { left } = values;
        this.setState({ left });
    }

    renderView({ style, ...props }) {
        const { left } = this.state;
        const viewStyle = {
            padding: 15,
            backgroundColor: `rgb(${Math.round(255 - (left * 255))}, ${Math.round(left * 255)}, ${Math.round(255)})`,
            color: `rgb(${Math.round(255 - (left * 255))}, ${Math.round(255 - (left * 255))}, ${Math.round(255 - (left * 255))})`,
            //height: 1+'px'
        };
        return (
            <div
                className="box"
                style={{ ...style, ...viewStyle }}
                {...props}/>
        );
    }

    renderThumb({ style, ...props }) {
    const { left } = this.state;

    // Get track width in pixels
    const track = document.querySelector('.track-horizontal');
    const trackWidth = track ? track.clientWidth : window.innerWidth * 0.9; // fallback 90vw in px

    const thumbWidth = 100; // px

    // Calculate left offset in px: max offset = trackWidth - thumbWidth
    const maxLeft = trackWidth - thumbWidth;

    // Calculate left position in px
    const leftPx = left * maxLeft;

    const thumbStyle = {
        backgroundColor: `rgb(${Math.round(255 - (left * 255))}, ${Math.round(255 - (left * 255))}, ${Math.round(255 - (left * 255))})`,
        position: 'absolute',
        left: `${leftPx}px`,
        width: `${thumbWidth}px`,
        height: '100%', // or fixed height
        cursor: 'pointer'
    };

    return (
        <div
            className="thumb-horizontal"
            style={{ ...style, ...thumbStyle }}
            {...props} />
    );
}


    render() {
        return (
            <Scrollbars
                renderView={props => <div {...props} className={"scrollbar-hide view " + props.className}/>}
                renderTrackHorizontal={props => <div {...props} className="track-horizontal"><div className="line"/></div>}
                //renderThumbHorizontal= {props => <div {...props}  className="thumb-horizontal"/>}
                renderThumbHorizontal={this.renderThumb}
                //renderThumbVertical={this.renderThumb}
                onUpdate={this.handleUpdate}
                {...this.props}/>
        );
    }
}
